import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import InviteStep from 'invite-sign/components/invite-steps/step';
import type { Step } from 'invite-sign/services/invite-steps';

interface InviteStepsSignature {
  Args: {
    steps: Step[];
  };
}
export default class InviteSteps extends Component<InviteStepsSignature> {
  @service declare router: RouterService;

  get currentStep(): number {
    const { currentRouteName } = this.router;
    const step = this.args.steps.findIndex((step) => {
      return step.route === currentRouteName || step.substeps?.find((substep) => substep.route === currentRouteName);
    });
    if (step !== -1) {
      return step;
    }
    return Number.MAX_SAFE_INTEGER;
  }

  <template>
    <ol data-test-steps-list class="list-none p-0 antialiased mb-0">
      {{#each @steps as |step index|}}
        <InviteStep @step={{step}} @index={{index}} @currentStep={{this.currentStep}} />
      {{/each}}
    </ol>
  </template>
}
